import logo from "../../assets/Images/VerticalDarkLogo1.svg";
import sat from "../../assets/Images/SATprep1.svg";
import { useNavigate } from "react-router-dom";
import AuthButton from "./LoginButton";
import { BiMailSend } from "react-icons/bi";
import { FcGoogle } from "react-icons/fc";
import { appleClientId, appleUrl, googleUrl } from "../../apiConfig";
import AppleLogin from "react-apple-login";
import { BsApple } from "react-icons/bs";
import OnboardingBackground from "../../components/ReUsableComponents/OnboardingBackground";

const SocialSignup = () => {
  const navigate = useNavigate();

  const handleGoogleSignUp = () => {
    window.open(googleUrl, "_self");
  };

  return (
    <OnboardingBackground>
      <div className="flex flex-col items-center h-[539px] w-[720px] p-6 rounded-2xl shadow-widget-card border border-satPrepGrey backdrop-blur-sevenFive bg-satPrepTransWhite">
        <img src={logo} className="w-[260px] h-[163px]" alt="FullMarks Logo" />
        <img src={sat} className="w-[214px] h-[68px]" alt="SATprep Logo" />

        <div className="gap-3 flex flex-col justify-center items-center py-9">
          <AuthButton
            text="Continue with Email"
            icon={<BiMailSend size={22} />}
            iconPosition="left"
            onClick={() => navigate("/register")}
            className="w-[246px] h-12"
          />
          <AppleLogin
            clientId={appleClientId}
            scope={"name email"}
            redirectURI={appleUrl}
            responseType={"code id_token"}
            responseMode={"form_post"}
            render={(renderProps) => (
              <button
                onClick={renderProps.onClick}
                className="w-[246px] h-12 rounded-md bg-white text-satPrepAccent border border-satPrepAccent py-[10px] px-[22px] flex justify-center font-medium font-gully cursor-pointer"
              >
                <BsApple className="text-black" size={24} />
                <p className="ml-2 pt-1.5">Continue with Apple</p>
              </button>
            )}
            usePopup={false}
          />
          <AuthButton
            text="Continue with Google"
            icon={<FcGoogle size={24} className="mb-1" />}
            iconPosition="left"
            onClick={handleGoogleSignUp}
            className="bg-white !text-satPrepAccent border border-satPrepAccent w-[246px] h-12 !pb-2"
          />
        </div>

        <div className="flex justify-center items-center gap-1">
          <p className="text-satPrepBlack align-middle font-normal">
            Already have an account?
          </p>
          <button
            className="underline text-satPrepDarkAccent flex justify-center text-base cursor-pointer font-normal"
            onClick={() => {
              navigate("/login");
            }}
          >
            Sign in!
          </button>
        </div>
      </div>
    </OnboardingBackground>
  );
};

export default SocialSignup;
